// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsScreeningReportsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreateReportsRequestDto, ListingAlias, ScreeningReportData } from '../..';

interface RetrieveReportsParams {
  listingAlias?: ListingAlias;
  requestingClient: string;
  zipCode?: string;
}

export const CappsScreeningReportsWebApiHandler_createReports_Path = '/api/web/renter/v1/reports/createReports';

export const CappsScreeningReportsWebApiHandler_createReports = (
  postData: CreateReportsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateReportsRequestDto, void>(
    {
      endpoint: CappsScreeningReportsWebApiHandler_createReports_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsScreeningReportsWebApiHandler_retrieveReports_Path = '/api/web/renter/v1/reports/retrieveReports';

export const CappsScreeningReportsWebApiHandler_retrieveReports = (
  getParams: RetrieveReportsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<RetrieveReportsParams, never, ScreeningReportData>(
    {
      getParams: getParams,
      endpoint: CappsScreeningReportsWebApiHandler_retrieveReports_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
